import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        products: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        productsExpo: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        quantity_cart: 0,
        cart: null,
        filters: null,
        notification: {
            show: false,
            message: '',
            type: ''
        }
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchCatalog({commit}, pagination) {
        const response = await axios.post(`/fastmarket/catalog?page=${pagination.currentPage}`, {...pagination});
        commit('SET_CATALOG', response.data)
    },
    async fetchCatalogExpo({commit}, pagination) {
        const response = await axios.post(`/fastmarket/catalog/expo?page=${pagination.currentPage}`, {...pagination});
        commit('SET_CATALOG_EXPO', response.data)
    },
    async getFilters({commit}, pagination) {
        const response = await axios.post(`/fastmarket/catalog/filters`, {...pagination});
        commit('SET_FILTERS', response.data)
    },
    async getFiltersExpo({commit}, pagination) {
        const response = await axios.post(`/fastmarket/catalog/filtersExpo`, {...pagination});
        commit('SET_FILTERS', response.data)
    },
    selectVariable({commit}, item){
        commit('SET_VARIABLE_CART', item)
    },
    selectVariableOrder({commit}, item){
        commit('SET_VARIABLE_ORDER', item)
    },
    resetVariable({commit}, item){
        commit('RESET_VARIABLE_CART', item)
        commit('RESET_NOTIFICATION')
    },
    resetVariableOrder({commit}, item){
        commit('RESET_VARIABLE_ORDER', item)
        commit('RESET_NOTIFICATION')
    },
    resetNotification({commit}){
        commit('RESET_NOTIFICATION')
    },
    async getCart({commit}){
        const response = await axios.get(`/fastmarket/catalog/cart`);
        commit('SET_CART', response.data.data)
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async addToCart({commit}, item){
        commit('RESET_NOTIFICATION')
        const response = await axios.post(`/fastmarket/catalog/cart/add`,item);
        commit('SET_QUANTITY_CART', response.data.quantity_cart)
        commit('SET_NOTIFICATION', {
            show: true,
            message: response.data.msg,
            type: response.data.result ? 'success' : 'danger'
        })
        setTimeout(function(){ commit('RESET_NOTIFICATION');}, 3000); 
        return response.data.result
    },
    async addToOrder({commit}, item){
        commit('ADD_PRODUCTS_TO_ORDER', item)
    },
    async plus({commit}, item){
        commit('RESET_NOTIFICATION')
        const response = await axios.post(`/fastmarket/catalog/cart/add`,item);
        commit('SET_QUANTITY_CART', response.data.quantity_cart)
        commit('SET_NOTIFICATION', {
            show: true,
            message: response.data.msg,
            type: response.data.result ? 'success' : 'danger'
        })
        setTimeout(function(){ commit('RESET_NOTIFICATION');}, 3000); 
    },
    async less({commit}, item){
        commit('RESET_NOTIFICATION')
        const response = await axios.post(`/fastmarket/catalog/cart/less`,item);
        commit('SET_QUANTITY_CART', response.data.quantity_cart)
        commit('SET_NOTIFICATION', {
            show: response.data.result,
            message: response.data.msg,
            type: response.data.result ? 'success' : 'danger'
        })
        setTimeout(function(){ commit('RESET_NOTIFICATION');}, 3000); 
    },
    async getCartCount({commit, rootState}){
        if(rootState.auth.currentUser !== null){
            const response = await axios.get(`/fastmarket/catalog/cart/count`);
            commit('SET_QUANTITY_CART', response.data.quantity_cart)
        }
    },
    async delete({commit}){
        const response = await axios.post(`/fastmarket/catalog/cart/delete`);
        commit('SET_CART', response.data.data)
        commit('SET_QUANTITY_CART', 0)
    },
    async confirm({commit}, data){
        const response = await axios.post(`/fastmarket/catalog/cart/confirm`, data);
            if(response.data.result){
                commit('SET_QUANTITY_CART', 0)
                return response.data.cart
            }else commit('SET_CART', response.data.cart)
    },
    async downloadPDF({commit}, product_id){
        const response = await axios.post(`/fastmarket/catalog/download`, {product_id: product_id}, { responseType: "blob" });
        const filename = `PRODUCT-` + product_id + '.pdf';
        downloadFile(filename, response.data);
    },

}

export const mutations = {
    updateField,
    ADD_PRODUCTS_TO_ORDER: (state, result) => {
        return result
    },
    SET_CATALOG: (state, result) => {
        state.products = {
            items: result.data,
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
    },
    SET_CATALOG_EXPO: (state, result) => {
        state.productsExpo = {
            items: result.data,
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
    },
    SET_VARIABLE_CART: (state, item) => {
        let product = state.products.items.find(p => p.id_product == item.id_product)
        let variable =  product.variables.data.find(v => v.id_product_attribute == item.id_product_attribute )
        variable.selected = !variable.selected
    },
    SET_VARIABLE_ORDER: (state, item) => {
        let product = state.productsExpo.items.find(p => p.id_product == item.id_product)
        let variable =  product.variables.data.find(v => v.id_product_attribute == item.id_product_attribute )
        variable.selected = !variable.selected
    },
    RESET_VARIABLE_CART: (state, item) => {
        let product = state.products.items.find(p => p.id_product == item.id_product)
        if(product !== undefined)
            for(var i = 0; i < product.variables.data.length; i++){
                product.variables.data[i].selected = false
            }
    },
    RESET_VARIABLE_ORDER: (state, item) => {
        let product = state.productsExpo.items.find(p => p.id_product == item.id_product)
        for(var i = 0; i < product.variables.data.length; i++){
            product.variables.data[i].selected = false
        }
    },
    SET_QUANTITY_CART: (state, quantity) => state.quantity_cart = quantity,
    SET_CART: (state, cart) => state.cart = cart,
    SET_FILTERS: (state, filters) => state.filters = filters,
    SET_NOTIFICATION: (state, noti) => state.notification = noti,
    RESET_NOTIFICATION: (state) => state.notification = { show: false, message: '', type: '' },
}